import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// TODO: add option for horizontal and vertical

import { Colors, FontSizes, FontWeights } from '../Theme';

const Tabs = ({ vertical, tabs, width }) => {
  const styles = {
    tabs: {
      display: 'flex',
      flexDirection: vertical ? 'column' : 'row',
      alignItems: 'center',
      borderTop: vertical ? null : '1px solid #e5e5e5',
      borderBottom: vertical ? null : '1px solid #e5e5e5',
      borderRight: vertical ? '1px solid #e5e5e5' : null,
      paddingRight: vertical ? 30 : null,
      alignSelf: 'stretch',
      minWidth: width || 200,
      flexShrink: 0
    },
    tab: {
      textAlign: vertical ? 'right' : 'center',
      width: vertical ? '100%' : 'auto',
      padding: vertical ? '12px 10px' : '16px 20px',
      margin: vertical ? '7px 0px' : '0px 0px -1px 0px',
      fontSize: FontSizes.MEDIUM,
      color: '#777',
      lineHeight: 1,
      cursor: 'pointer',
      textDecoration: 'none'
    },
    active_tab: {
      padding: vertical ? '12px 10px' : '16px 20px 12px 20px',
      fontWeight: FontWeights.BOLD,
      color: Colors.GRAY.hex,
      borderBottom: vertical ? null : `4px solid ${Colors.PRIMARY.hex}`,
      borderRadius: vertical ? 8 : 0,
      backgroundColor: vertical ? `rgba(${Colors.PRIMARY.rgb}, 0.1)` : null
    }
  };

  return (
    <div style={styles.tabs}>
      {tabs.map((tab, i) =>
        tab.to ? (
          <Link
            key={i}
            onClick={tab.onClick}
            style={Object.assign({}, styles.tab, tab.isActive && styles.active_tab)}
            to={tab.to}
          >
            {tab.label}
          </Link>
        ) : (
          <div
            key={i}
            onClick={tab.onClick}
            style={Object.assign({}, styles.tab, tab.isActive && styles.active_tab)}
          >
            {tab.label}
          </div>
        )
      )}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      isActive: PropTypes.bool
    })
  ),
  vertical: PropTypes.bool,
  width: PropTypes.number
};

export default Tabs;
